module.exports = __webpack_public_path__ + "img/product_view_scroll_bg.24555e6d.jpg";